<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-22 11:04:44
 * @LastEditTime: 2020-11-23 11:07:43
-->
<template>
  <div v-if="dialogVisible">
     <el-dialog
      :title="$t('lang.usercontrol.change_password')"
      :visible.sync="dialogVisible"
      width="40%"
      center>
      <div class="concen">
        <el-form :model="newpass" ref="editPwd" :rules="rules" label-width="190px" label-position="right">
          <el-form-item :label="`${$t('lang.usercontrol.New_Object')}：`" prop="newpassword">
             <el-input :type="inputType" v-model="newpass.newpassword" class="adduserinput" size="mini"></el-input>
             <span style="margin-left: 10px; cursor: pointer;">
               <i class="el-icon-view" @click="viewPwd"></i>
             </span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.changePassword')}：`" prop="affirmpassword">
             <el-input type="password" v-model="newpass.affirmpassword" class="adduserinput" size="mini"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">{{$t('lang.usercontrol.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="changePassword">{{$t('lang.usercontrol.Determine')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { changePassword } from "@/api/usercontrol";
export default {
  data() {
    var VerificationPassword = (rule, value, callback) => {
      let password = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,16}$/;
      if(password.test(value) == false){
        return callback(new Error(this.$t('lang.usercontrol.errmessage2')))
      }else {
        callback()
      }
    }
    var reCheckPassword = (rule, value, callback) => {
      if(value !== this.newpass.newpassword){
        return callback(new Error(this.$t('lang.usercontrol.errmessage6')))
      }else {
        callback()
      }
    }
    return {
      dialogVisible: false,
       newpass: {
        user_id: null,
        newpassword: "",
        affirmpassword: "",
      },
      inputType: 'password',
      rules: {
        newpassword: [
          { required: true, validator: VerificationPassword, trigger: 'blur' }
        ],
        affirmpassword: [
          { required: true, validator: reCheckPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    show(user_id) {
      this.newpass = {
        user_id: null,
        newpassword: "",
        affirmpassword: "",
      }
      this.newpass.user_id = user_id
      this.dialogVisible = true
    },
    changePassword() {
      this.$refs.editPwd.validate(valid => {
        if(valid) {
          changePassword(this.newpass.user_id, this.newpass.newpassword).then(res => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message9"),
                type: "success"
              });
              this.$emit('queryKeyword')
              this.dialogVisible = false
            } else if (res.data.code === 11) {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message10"),
                type: "error"
              });
            }
          });
        }else{
          return false
        }
      })
    },
    //设置密码是否显示
    viewPwd() {
      if(this.inputType === 'password') {
        this.inputType = ''
      }else{
        this.inputType = 'password'
      }
    }
  }
}
</script>
<style scoped>
.adduserinput {
  width: 4rem;
}
.concen{
  display: flex;
  justify-content: center;
  
}
</style>